import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';

type IDependencies = IClientApiDependencySegment;

export const updateSymbolSyntheticEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.update.started),
  mergeMap((params) => {
    const { resolve, reject } = params;

    return dependencies.api.updateSyntheticSymbol({
      symbolId: params.symbolId,
      priceDigits: params.priceDigits,
    }).pipe(
      mergeMap(() => {
        resolve?.();
        return [
          SymbolSyntheticAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          SymbolSyntheticAction.update.failed({ params, error: null }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
